'use client';

import { useEffect } from 'react';
import ModuleList, {
  Module,
} from '@/components/utilities/content-modules/module-list/module-list';
import {
  trackPageLoadEvent,
  trackViewEvent,
} from '@/integrations/tracking/google-tag-manager/scripts';
import { tealiumView } from '@/integrations/tracking/tealium/scripts';
import TravelPortalCampaignPageHeader from './travelportal-campaign-page-header/travelportal-campaign-page-header';
import TravelPortalCampaignPageResults from './travelportal-campaign-page-results/travelportal-campaign-page-results';
import styles from './travelportal-campaign.module.scss';

export interface TravelPortalCampaignProps {
  /** An array of the content modules to show */
  contentModules: Module[];
  /** An array of the header modules to show */
  headerModules: Module[];
  /** Personalization data for the user */
  personalizationData?: Content.Properties.PersonalizationData;
  /** Search settings for filters and search bar */
  searchSettings: Content.Components['TravelPortalSearchSettingsDto'];
  /** Tracking data for the page */
  trackingData?: Content.Properties.TrackingData;
}

const TravelPortalCampaign = ({
  contentModules,
  headerModules,
  personalizationData,
  searchSettings,
  trackingData,
}: TravelPortalCampaignProps) => {
  useEffect(() => {
    trackPageLoadEvent({ content_group: 'travelportal_campaign' });

    personalizationData && tealiumView(personalizationData);

    if (!trackingData?.gtmDataLayer) return;

    trackViewEvent(trackingData.gtmDataLayer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.component}>
      <ModuleList modules={headerModules} />

      <TravelPortalCampaignPageHeader searchSettings={searchSettings} />

      <TravelPortalCampaignPageResults searchSettings={searchSettings} />

      <ModuleList modules={contentModules} />
    </div>
  );
};

TravelPortalCampaign.displayName = 'TravelPortalCampaign';

export default TravelPortalCampaign;
